import {SODeleteRolePermission} from '../../core/role-permission/so-delete-role-permission';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteRolePermission extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteRolePermission;
}